const updateItems = [
  {
    time: '10分钟前',
    title: '某顶流艺人合同纠纷最新进展曝光',
    tag: '娱乐圈',
    summary: '知情人士透露多份内部文件，涉及巨额违约金条款。',
  },
  {
    time: '45分钟前',
    title: '知名直播平台数据泄露事件扩大',
    tag: '科技',
    summary: '受影响用户数量持续增加，平台方尚未发布正式声明。',
  },
  {
    time: '2小时前',
    title: '综艺节目录制现场冲突视频流出',
    tag: '综艺',
    summary: '节目组与嘉宾发生争执，完整视频已在社区热传。',
  },
  {
    time: '4小时前',
    title: '某上市公司财报造假新证据',
    tag: '商业',
    summary: '内部审计报告曝光，涉及数十亿资金异常流转。',
  },
  {
    time: '7小时前',
    title: '网红MCN机构霸王条款全曝光',
    tag: '网红',
    summary: '多位签约主播联合爆料，揭露行业潜规则与不公平合约。',
  },
  {
    time: '11小时前',
    title: '海外体育赛事裁判受贿录音曝光',
    tag: '体育',
    summary: '多场比赛结果被质疑，国际体育组织已启动调查程序。',
  },
  {
    time: '18小时前',
    title: '黑料社独家：政商圈利益输送链完整起底',
    tag: '政商',
    summary: '历时三个月追踪调查，揭开跨行业利益网络的全貌。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
              最新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              24小时滚动更新的最新爆料动态
            </p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-primary-600 font-medium">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse" />
            实时更新中
          </span>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] top-2 bottom-2 w-px bg-background-300" />

          <div className="space-y-6">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex gap-5 pl-10">
                <span className="absolute left-0 top-1.5 w-[30px] h-[30px] flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold border-2 border-background-100 shrink-0">
                  {i + 1}
                </span>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-300/40 transition-all cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-[10px] font-bold">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}